import { getAbsoluteUrl } from '@/utils/seo'

interface BuildArticleStructuredDataInput {
  cleanTitle: string
  description: string
  author: string
  publisherName: string
  publisherLogoUrl: string
  publishedTime?: string
  modifiedTime?: string
  pageOgImage: string
  pageCanonicalUrl: string
  hostname?: string
}

export function getSeoContentType(
  pathname: string,
  fallbackType: 'website' | 'article' | 'video.other' | 'profile',
  hasVideoUrl: boolean
): 'website' | 'article' | 'video.other' | 'profile' {
  if (pathname.includes('/blogs/')) return 'article'
  if (pathname.includes('/webinars/') && hasVideoUrl) return 'video.other'
  if (pathname.includes('/meme')) return 'article'
  if (pathname.includes('/topic/') || pathname.includes('/forum/')) return 'article'
  if (pathname.includes('/courses/')) return 'article'
  return fallbackType
}

export function buildArticleStructuredData({
  cleanTitle,
  description,
  author,
  publisherName,
  publisherLogoUrl,
  publishedTime,
  modifiedTime,
  pageOgImage,
  pageCanonicalUrl,
  hostname,
}: BuildArticleStructuredDataInput) {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: cleanTitle,
    description,
    author: {
      '@type': 'Person',
      name: author,
    },
    publisher: {
      '@type': 'Organization',
      name: publisherName,
      logo: {
        '@type': 'ImageObject',
        url: getAbsoluteUrl(publisherLogoUrl, hostname),
      },
    },
    datePublished: publishedTime,
    dateModified: modifiedTime || publishedTime,
    image: pageOgImage,
    url: pageCanonicalUrl,
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': pageCanonicalUrl,
    },
  }
}
